// extracted by mini-css-extract-plugin
export default {"categoryBtn":"CategoryButton_categoryBtn__2lLmf"};